import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonRoutingModule } from './button-routing.module';
import { ButtonComponent } from './button.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {ButtonModule} from "../../component/ing/button/button";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    ButtonRoutingModule,
    ButtonModule,
    TableModule
  ],
  declarations: [
  	ButtonComponent
  ]
})
export class ButtonDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/button/buttonDemo.module.ts